module.exports={render:function (){with(this) {
  return _h('nav', {
    staticClass: "top-nav",
    class: lights
  }, [_h('div', {
    staticClass: "bg"
  }, [_h('div', {
    staticClass: "bg-ma",
    style: ({
      'background-image': 'url(' + this.bg + ')'
    })
  }), " ", _m(0)]), " ", _h('div', {
    staticClass: "nav-content"
  }, [_h('ul', {
    staticClass: "nav"
  }, [_h('li', [_h('router-link', {
    attrs: {
      "to": {
        path: '/'
      },
      "title": "主站"
    }
  }, ["主站"])]), " ", _h('li', [_h('router-link', {
    attrs: {
      "to": {
        path: '/'
      },
      "title": "画友"
    }
  }, ["画友"])]), " ", _h('li', [_h('router-link', {
    staticClass: "show-tag",
    attrs: {
      "to": {
        path: '/'
      },
      "title": "游戏中心",
      "id": "gameCenter"
    }
  }, ["游戏中心"]), " ", _h('div', {
    staticClass: "show-content"
  }, [_m(1), " ", _h('div', {
    staticClass: "right"
  }, [_m(2), " ", _h('div', {
    staticClass: "all"
  }, [_l((ranks), function(rank) {
    return _h('a', {
      attrs: {
        "target": "_blank",
        "href": rank.url
      },
      on: {
        "mouseover": function($event) {
          show(rank.img)
        },
        "mouseout": leave
      }
    }, [_h('span', [_s(rank.text)])])
  })])]), " ", _m(3)])]), " ", _h('li', [_h('router-link', {
    staticClass: "show-tag",
    attrs: {
      "to": {
        path: '/'
      },
      "title": "直播",
      "id": "online"
    }
  }, ["直播"]), " ", _m(4)]), " ", _h('li', [_h('router-link', {
    attrs: {
      "to": {
        path: '/'
      },
      "title": "周边"
    }
  }, ["周边"])]), " ", _h('li', [_h('router-link', {
    staticClass: "phone",
    attrs: {
      "to": {
        path: '/'
      },
      "title": "移动端"
    }
  }, [_m(5), " ", _m(6)])])]), " ", _h('div', {
    staticClass: "user-box"
  }, [_h('ul', [_m(7), " ", _m(8), " ", _m(9), " ", _h('li', {
    staticClass: "none"
  }, [_h('router-link', {
    staticClass: "i-link",
    attrs: {
      "to": {
        path: '/'
      },
      "title": "投稿"
    }
  }, ["投 稿"]), " ", _m(10)])])])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "bg-model"
  })
}},function (){with(this) {
  return _h('div', {
    staticClass: "left"
  }, [_h('div', {
    staticClass: "banner"
  }, [_h('a', {
    attrs: {
      "target": "_blank",
      "href": "http://vipgift.biligame.com/"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/game/32bbcb85fb7c344f30f46a5b30f9219243ec9740.jpg",
      "alt": "大会员礼包"
    }
  }), " ", _h('span', ["大会员礼包"])])]), " ", _h('div', {
    staticClass: "brief clearfix"
  }, [_h('a', {
    attrs: {
      "target": "_blank",
      "title": "命运-冠位指定（Fate/GO）",
      "href": "http://acg.tv/u1Hz"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/game/f7d4ee0877089e4079b8f0b4f5c95dd4ceba512a.png",
      "alt": "命运-冠位指定（Fate/GO）"
    }
  }), " ", _h('span', ["命运-冠位指定（Fate/GO）"])]), " ", _h('a', {
    attrs: {
      "target": "_blank",
      "title": "如果的世界",
      "href": "http://rgdsj.biligame.com/"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/game/b8132ed0de34f1cd53bab5e2a40c9f48c01542fb.png",
      "alt": "如果的世界"
    }
  }), " ", _h('span', ["如果的世界"])]), " ", _h('a', {
    attrs: {
      "target": "_blank",
      "title": "阴阳师",
      "href": "http://yys.biligame.com/"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/game/3b205675d44bbd90e6ea46d4baec9674bda6e642.png",
      "alt": "阴阳师"
    }
  }), " ", _h('span', ["阴阳师"])])])])
}},function (){with(this) {
  return _h('a', {
    staticClass: "bbs",
    attrs: {
      "target": "_blank",
      "href": "http://bbs.biligame.com"
    }
  }, ["游戏论坛"])
}},function (){with(this) {
  return _h('div', {
    staticClass: "imgdiv",
    attrs: {
      "style": "background-repeat: no-repeat;"
    }
  })
}},function (){with(this) {
  return _h('div', {
    staticClass: "show-content live-box"
  }, [_h('div', {
    staticClass: "live-lf"
  }, [_h('p', {
    staticClass: "title"
  }, ["热门直播:"]), " ", _h('div', {
    staticClass: "lf-list"
  }, [_h('a', {
    staticClass: "lf-item",
    attrs: {
      "href": "http://live.bilibili.com/1169523",
      "target": "_blank"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/face/0a3635d76b2dcb6379dc84d27b03dbc892123c93.jpg"
    }
  }), _h('i', ["LIVE"]), _h('p', ["番茄君也是水果"])]), " ", _h('a', {
    staticClass: "lf-item",
    attrs: {
      "href": "http://live.bilibili.com/291263",
      "target": "_blank"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/face/fa6f9fabb7bdf08f413fe6d0a99ad74bbadfab4e.jpg"
    }
  }), _h('i', ["LIVE"]), _h('p', ["许仙大官人丶"])]), " ", _h('a', {
    staticClass: "lf-item",
    attrs: {
      "href": "http://live.bilibili.com/191313",
      "target": "_blank"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/face/9c6cda4e0d0fcbe54817a4f0b455b15e1895b537.jpg"
    }
  }), _h('i', ["LIVE"]), _h('p', ["蠢棉"])]), " ", _h('a', {
    staticClass: "lf-item",
    attrs: {
      "href": "http://live.bilibili.com/18057",
      "target": "_blank"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i1.hdslb.com/bfs/face/6da3e04dcb01237af3b9b446d39121e67009b1f6.jpg"
    }
  }), _h('i', ["LIVE"]), _h('p', ["旋转的亚索"])]), " ", _h('a', {
    staticClass: "lf-item",
    attrs: {
      "href": "http://live.bilibili.com/24838",
      "target": "_blank"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i1.hdslb.com/bfs/face/7d6b5a8952d6b6162a3777634d1e432ebfbfc216.jpg"
    }
  }), _h('i', ["LIVE"]), _h('p', ["二五八万KT"])]), " ", _h('a', {
    staticClass: "lf-item",
    attrs: {
      "href": "http://live.bilibili.com/272849",
      "target": "_blank"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i2.hdslb.com/bfs/face/291b06d44fb15321a629239f945a4aa4ac45a792.jpg"
    }
  }), _h('i', ["LIVE"]), _h('p', ["猴叔w"])])])]), " ", _h('div', {
    staticClass: "live-lr"
  }, [_h('p', {
    staticClass: "title title2"
  }, ["热门活动:"]), " ", _h('div', {
    staticClass: "banner"
  }, [_h('a', {
    attrs: {
      "href": "http://live.bilibili.com/hd/aki2016",
      "target": "_blank",
      "title": "红叶祭二阶开放啦"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/live/46cb3071202cd942602692071d61f07143e5fd34.jpg"
    }
  })]), " ", _h('a', {
    attrs: {
      "href": "http://live.bilibili.com/hd/momiji",
      "target": "_blank",
      "title": "红叶祭三阶-miss 椛总选举"
    }
  }, [_h('img', {
    attrs: {
      "src": "http://i0.hdslb.com/bfs/live/71e0b3cb7cde56ddd0da73860016ad690c4e01b8.jpg"
    }
  })])])])])
}},function (){with(this) {
  return _h('span', ["移动端"])
}},function (){with(this) {
  return _h('div', {
    staticClass: "mobile-p-box"
  }, [_h('div', {
    staticClass: "mobile-p-qrcode"
  })])
}},function (){with(this) {
  return _h('li', [_h('a', {
    attrs: {
      "href": "https://passport.bilibili.com/login",
      "target": "_blank",
      "title": "登录"
    }
  }, ["登录"])])
}},function (){with(this) {
  return _h('i', {
    staticClass: "s-line"
  })
}},function (){with(this) {
  return _h('li', [_h('a', {
    attrs: {
      "href": "https://passport.bilibili.com/register/phone",
      "target": "_blank",
      "title": "注册"
    }
  }, ["注册"])])
}},function (){with(this) {
  return _h('ul', {
    staticClass: "s-menu"
  }, [_h('li', [_h('a', {
    attrs: {
      "href": "http://member.bilibili.com/v/video/submit.html",
      "target": "_blank"
    }
  }, [_h('i', {
    staticClass: "b-icon b-icon-vp"
  }), " ", _h('span', ["视频投稿"])])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "http://member.bilibili.com/v/#!/article",
      "target": "_blank"
    }
  }, [_h('i', {
    staticClass: "b-icon b-icon-vm"
  }), " ", _h('span', ["投稿管理"])])]), " ", _h('li', [_h('a', {
    attrs: {
      "href": "http://member.bilibili.com/v/video/submit.html",
      "target": "_blank"
    }
  }, [_h('i', {
    staticClass: "b-icon b-icon-vc"
  }), " ", _h('span', ["创作中心"])])])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/template-compiler.js?id=data-v-4!./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopNav.vue
 ** module id = 35
 ** module chunks = 2
 **/